import {postJson} from "@/ajax/http";
import {ApiUrl, ApiToken} from '@/config/sys.config'

export const chatApi = {
    stopChat: (taskId, data) => {
        let url = ApiUrl + `/chat-messages/${taskId}/stop`;
        let headers = {
            'Authorization': 'Bearer ' + ApiToken
        }
        return postJson(url, data, headers);
    },
}
